export default __webpack_public_path__ + "static/case-study-bddf53de3196dc196b5b86725b9c37ec.png";